import i18n from '../locales/index'
import { Message } from 'view-design'
import ais from 'axios';

const axios = ais.create({
  baseURL: process.env.VUE_APP_AI_API_HOST, // url = base url + request url
});
axios.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    if (error.response) {
      if (/^401$/.test(error.response.status)) {
        Message.error(error.response.data.message)
        setToken('')
        router.replace('/login')
      } else if (/^4.*/.test(error.response.status)) {
        Spin.hide()
        Message.error({ content: error.response.data.message, duration: 3 })
      } else {
        Message.error(error.response.data.message)
      }
    }
    return Promise.reject(error.response)
  }
)
export default axios
